import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { logged } from "../services/auth";
import * as UserService from "../services/user";

const useProfile = () => {
  const [loading, setLoading] = useState();

  const [userProfile, setUserProfile] = useState(JSON.parse(localStorage.getItem("user")));
  const [defaultVolume, setVolumeTrack] = useState(0);

  const updateProfile = async (user) => {
    try {
      // Update backend
      await UserService.updateUser(user.id, user);
      // Update localStorage on success
      localStorage.setItem("user", JSON.stringify(user));
    } catch (error) {
      console.error("Failed to update profile:", error);
      // Optionally re-throw or handle the error
      throw error;
    }
  };

  return { userProfile, loading, defaultVolume, setVolumeTrack, updateProfile };
};

export { useProfile };
